import { Injectable } from '@angular/core';
import { Error } from '@bilancio/api';
import { CoreActions, SuperStore } from '@bilancio/root-store';

@Injectable({ providedIn: 'root' })
export class ErrorSandbox {
  constructor(private readonly store: SuperStore) {}

  manageError(errorObj: Error.ErrorObj) {
    const url = 'errorPage';
    this.store.dispatch(CoreActions.setError({ errorObj }));
    this.store.dispatch(CoreActions.navigateByUrl({ url }));
  }

  showToast(msg: string) {
    this.store.dispatch(
      CoreActions.showToastMessage({
        typeToast: 'warning',
        visible: true,
        title: 'Attenzione',
        msg,
        timeout: false,
      }),
    );
  }

  public getMessage(code: number): string {
    let msg = 'Ops! Qualcosa è andato storto…';
    if (code === 400) {
      // errore di validazione
      msg = 'Sembra ci sia un problema nella tua richiesta…';
    } else if (code === 401) {
      // errore di autenticazione (gestito sull'interceptor)
      msg = 'Sembra che la tua sessione sia scaduta…';
    } else if (code === 403) {
      // errore di permessi  (gestito sull'interceptor)
      msg = 'Non hai le autorizzazioni necessarie per accedere';
    } else if (code === 409) {
      // errore di metering
      msg = 'Sembra ci sia un problema con la tua licenza…';
    } else if (code === 500) {
      // errore generico
      msg = 'Si è verificato un errore interno del server. Ti preghiamo di riprovare.';
    }
    return msg;
  }

  public getBoldMessage(code: number): string {
    let msg = Error.DefaultBoldMsg;
    if (code === 409) {
      // errore di metering
      msg =
        'Hai superato il numero di anagrafiche gestibili con la tua licenza. ' +
        'Contatta il tuo commerciale di riferimento e ampia la tua licenza o rimuovi anagrafiche clienti già esistenti per liberare spazio';
    }
    return msg;
  }

  public getImage(code: number): string {
    let img = 'Illustrazione-errore.svg';
    if (code === 400) {
      // errore di validazione
      img = 'illustrazione-400.svg';
    } else if (code === 401) {
      // errore di autenticazione (gestito sull'interceptor)
      img = 'illustrazione-401.svg';
    } else if (code === 403) {
      // errore di permessi  (gestito sull'interceptor)
      img = 'Illustrazione-403.svg';
    } else if (code === 500) {
      // errore generico
      img = 'illustrazione-500.svg';
    }
    return img;
  }
}
